<div fxLayoutAlign="center">
  <h1 style="margin-top: 20px;">Workers' Compensation Exemption Registration Detail
  </h1>
</div>
<div fxLayoutAlign="center">
  <h4>Exemption Registration details cannot be edited. This detail reflects the current state of the Workers'
    Compensation Exemption Registration in the system.
  </h4>
</div>
<!-- 000175166 -->
<div fxLayoutAlign="end" style="margin-right: 100px">
  <mat-icon  style="cursor: pointer" (click)="onPrint()">print</mat-icon>
</div> 
<div class="row" style="margin-left: 20px;margin-right: 20px">
  <div class="col-3" style="padding-right:100px">
    <div class="row"><a (click)="returnSearch()">Return to Search</a></div>
    <div class="bottom-line"></div>
    <div class="row" *ngIf="exemptionData?.isActiveStatus"> <a  [style.pointer-events]="isLinkClicked ?'none':'auto'" (click)="fileRenewal()">File a Renewal</a></div>
    <div class="bottom-line"></div>
    <div class="row"><a  [style.pointer-events]="isRequestCopyLinkClicked ?'none':'auto'" (click)="fileRequestCopy()">Request a Copy</a></div>
    <div class="bottom-line"></div>
  </div>
  <div class="col-5">
    <div ><h4>Registration Details</h4>
    </div>
    <div class="bottom-line"></div>
    <div class="row">
      <div class="col-6" style="text-align: right;font-weight: bold;">Registration Control #</div>
      <div class="col-6">{{exemptionData?.registrationControlNumber }}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Applicant Name
      </div>
      <div class="col-6">
        {{ exemptionData?.lastName ? exemptionData?.firstName ? exemptionData?.lastName+ ', ' : exemptionData?.lastName: '' }}
        {{  exemptionData?.firstName ? exemptionData?.firstName : '' }}
        {{  exemptionData?.middleName ? ' ' + exemptionData?.middleName : '' }}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Qualification Type
      </div>
      <div class="col-6">{{exemptionData?.qualificationType?.description}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Business Entity Name
      </div>
      <div class="col-6">{{exemptionData?.filingEntityName}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Entity Control #
      </div>
      <div class="col-6">{{exemptionData?.entityControlNumber}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Status
      </div>
      <div class="col-6">{{exemptionData?.externalStatusType?.description }}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Effective Date
      </div>
      <div class="col-6">{{exemptionData?.filingDate  | date: 'MM/dd/yyyy'}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Expiration Date
      </div>
      <div class="col-6">{{exemptionData?.expirationDate  | date: 'MM/dd/yyyy'}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">State License #
      </div>
      <div class="col-6">{{exemptionData?.stateLicense?.licenseNumber}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">State License Expiration
      </div>
      <div class="col-6">{{exemptionData?.stateLicense?.licenseExpirationDate | date: 'MM/dd/yyyy'}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Mailing Address
      </div>
      <div class="col-6">{{exemptionData?.mailingAddress?.formattedAddressWithAddressType}}</div>
    </div>
    <div class="row">
      <div class="col-6" style="text-align: right; font-weight: bold;">Physical Address
      </div>
      <div class="col-6">{{exemptionData?.physicalAddress?.formattedAddressWithAddressType}}</div>
    </div>
  </div>
  <div class="col-1"></div>
  <div class="col-3">
    <div ><h4>Registration History</h4>
    </div>
    <div class="bottom-line"></div>
    <div *ngFor="let ht of historyData" class="container">
      <div fxLayout="row" class="mt-2">
        <details style="width: 100%">
          <summary>
            <div style="margin-top: -20px;margin-left: 20px;" fxLayout="row" fxLayoutAlign="space-between center">
              <div>{{ht.summary}}</div>
              <div>{{ht.createdDate | date:'short'}}</div>
            </div>
          </summary>
          <div [innerHtml]="ht.detail | sanitizeHtml"></div>
        </details>
      </div>
      <div class="bottom-line"></div>
    </div>
  </div>
</div>
